import React, { useEffect } from 'react';
import { useLocation } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import {
  onBreadcrumbsHandler,
  // onBreadcrumbsHandlerIgnoreLatest,
  onBreadcrumbsHandlerMultiLevel,
} from '@src/hooks/useBreadcrumbs';

export const RouteWrapper = ({
  Component,
  routeName,
  isSuperConnector = false,
  ...rest
}) => {
  const [setBreadcrumbs] = onBreadcrumbsHandler();
  const [setBreadcrumbsMultiLevel] = onBreadcrumbsHandlerMultiLevel();

  const location = useLocation();

  const breadcrumbsHandler = () => {
    if (isSuperConnector) {
      // Custom breadcrumb logic for super connector routes
      setBreadcrumbsMultiLevel(location);
    } else {
      setBreadcrumbs(location);
    }
  };

  useEffect(() => {
    // setPath({ location, navigate, params });
    breadcrumbsHandler();
  }, [location]);

  return <Component {...rest} />;
};
